import { createProvider } from '@clutter/wt';

import { WT_COOKIE_DOMAIN, WT_COOKIE_EXPIRES, WT_TRACKER_DOMAIN, WT_TRACKER_URL } from '@shared/config/wt';
import { PlatformWTEventParams, wt } from '@shared/utils/wt_platform';
import { EventWithSchema } from '@shared/wt';

import { CUSTOMER_ID } from '@portal/config/customer';

wt.initialize({
  trackerDomain: WT_TRACKER_DOMAIN,
  trackerUrl: WT_TRACKER_URL,
  cookieOptions: {
    domain: WT_COOKIE_DOMAIN,
    expires: WT_COOKIE_EXPIRES,
  },
});
wt.set({ customer_id: CUSTOMER_ID });
wt.track('pageview');

const WT_PAGE_UUID = wt.getUUIDToken();

type PortalTrackParams = PlatformWTEventParams | EventWithSchema;

export const track = (params: PortalTrackParams | string) => {
  wt.track(params as PlatformWTEventParams | string);
};

const { WTProvider, useTrack: innerUseTrack } = createProvider<PortalTrackParams>(track);

export const useTrack = innerUseTrack as (
  params?: Partial<PortalTrackParams>,
) => (params: Partial<PortalTrackParams>) => void;

export { WTProvider, wt, WT_PAGE_UUID };
